export const ProjConstants = {
  HOME_ROUTE: '/',
  PARAM_SEPARATOR: '__',
  STATE_UUID: '6f86292b-dd9a-4987-bb8f-c3940263b349',
  FORECAST_STATE_UUID: '2b9beab2-1495-4f05-b4da-29761ebeb2ee',
  STATE_NAME: 'AP',
  FORECAST_STATE_NAME: 'ANDHRA PRADESH',
  STATE_BOUNDS: [[12.60004, 76.75599], [19.15689, 84.76102]],
  FORECAST_WORKSPACE_NAME: 'forecast',
  APWRIMS_WORKSPACE_NAME: 'APWRIMS',
  ADMIN_PANEL_UUID: '1275e5d8-ac8c-4052-85ab-e30d4d61d62b',
  GROUPS_UUID: 'a0ab9554-2af3-4d80-a227-807e323ddea5'
};

export const PROJECT_CONSTANTS = {
  APPLICATION_NAME:'App Builder',
  USERMGMT_APP_NAME: 'User Management'
}